__webpack_require__.p = "https://assets.canny.io/566921398251e2d690b84d3a38fcbd78b56d7fe1/";